export function isElementInViewport(el?: HTMLElement) {
  if (!el) {
    return false;
  }

  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  // 关键条件判断（部分可见逻辑）：
  return (
    rect.top < windowHeight && // 元素顶部未滚出视口底部
    rect.bottom > 0 && // 元素底部未滚出视口顶部
    rect.left < windowWidth && // 元素左侧未滚出视口右侧
    rect.right > 0 // 元素右侧未滚出视口左侧
  );
}
